/** @format */

import { computed, inject, Injectable, signal } from '@angular/core';
import { ViewportRuler } from '@angular/cdk/overlay';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DeviceService } from './device.service';

@Injectable({
	providedIn: 'root'
})
export class BreakpointsService {
	private viewportRuler = inject(ViewportRuler);
	private deviceService = inject(DeviceService);

	private readonly _viewportWidth = signal<number>(0);
	// If you use this, use debounceTime - it will fire ~10 times per second otherwise
	public readonly viewportWidth = this._viewportWidth.asReadonly();

	// The current screen breakpoint, using the current breakpoints from Homefield.
	public breakpoint = computed(() =>
		this.deviceService.getBreakPointNewFromSize(this._viewportWidth())
	);

	/**
	 * The current screen breakpoint.
	 * @deprecated Use new breakpoints when possible!
	 */
	public breakpointOld = computed(() =>
		this.deviceService.getBreakPointFromSize(this._viewportWidth())
	);

	constructor() {
		this.setWidth();

		this.viewportRuler
			.change(100)
			.pipe(takeUntilDestroyed())
			.subscribe(() => {
				this.setWidth();
			});
	}

	private setWidth() {
		this._viewportWidth.set(this.viewportRuler.getViewportSize().width);
	}
}
